// extracted by mini-css-extract-plugin
export default {"recos":"S8-z","productCardOverride":"T8-z","rowHasBadge":"U8-z"};